import {useStyles} from '../../../../shared/hooks/styles';

export const useHistoryTabStyles = () => {
  return useStyles(({theme}) => ({
    colText: {
      ...theme.fonts.h5Light,
      color: theme.color.textColor,
    },
    colTextPrimary: {
      ...theme.fonts.h5Light,
      color: theme.color.primaryColor,
    },
    colTextSecondary: {
      ...theme.fonts.h5Light,
      color: theme.color.iconGrayColor,
    },
  }));
};
